import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Star, Users, Shield } from 'lucide-react';
import AppImage from '../../../components/AppImage';

export default function Hero() {
  return (
    <section id="hero" className="bg-gradient-to-b from-secondary/5 to-background">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-16 md:py-24">
        
        {/* Trust indicators */}
        <div className="flex justify-center items-center gap-6 mb-2 text-sm text-muted-foreground">
          <div className="flex items-center gap-2">
            <Shield className="w-4 h-4" />
            <span>Secure & Private</span>
          </div>
          <div className="flex items-center gap-2">
            <Users className="w-4 h-4" />
            <span>10,000+ Users</span>
          </div>
          <div className="flex items-center gap-1">
            <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
            <span>4.8/5 Rating</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="text-center md:text-left">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-foreground mb-6">
              Career growth that 
              <span className="text-primary block">actually fits</span>
              your job.
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground mb-2 max-w-lg">
              SkillBinder gives you personalized plans, exercises, and salary insights—tailored to your specific occupation and experience level.
            </p>
            
            <div className="flex flex-col sm:flex-row items-center gap-4 mb-6">
              <Link 
                to="/authentication" 
                className="group w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-xl bg-primary text-primary-foreground px-8 py-1 hover:bg-primary/90 transition-all duration-200 font-semibold text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              >
                Start Free / Sign In
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link 
                to="/subscription-management" 
                className="w-full sm:w-auto inline-flex items-center justify-center rounded-xl bg-card text-primary px-8 py-1 border-2 border-primary hover:bg-primary/5 transition-all duration-200 font-medium text-lg"
              >
                View Premium — $19.99/mo
              </Link>
            </div>
            
            <p className="text-sm text-muted-foreground flex items-center justify-center md:justify-start gap-4">
              <span>✓ No ads</span>
              <span>✓ Cancel anytime</span>
              <span>✓ Secure checkout</span>
            </p>
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <AppImage 
                className="rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" 
                src="/assets/images/hotel-1757517445014.png" 
                alt="Professional female hospitality worker in formal uniform representing hotel and restaurant industry" 
                loading="eager"
              />
              <AppImage 
                className="rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" 
                src="/assets/images/female_construction-1757516239713.png" 
                alt="Professional female construction worker in orange safety vest and hard hat representing trades and construction professionals" 
              />
            </div>
            <div className="space-y-4 pt-8">
              <AppImage 
                className="rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" 
                src="/assets/images/male_mechanic.png" 
                alt="Professional male mechanic working in automotive service" 
              />
              <AppImage 
                className="rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" 
                src="/assets/images/nail_clerk-1757517276304.png" 
                alt="Professional nail technician working in modern salon representing beauty and personal care professionals" 
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}